'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.convertPlayablesForPlayback = convertPlayablesForPlayback;
exports.convertPlayable = convertPlayable;
function streamToPlayable(playable) {
  return playable.streams.find(function (s) {
    return s.selected === true;
  }) || playable.streams[0];
}

function convertPlayablesForPlayback(playables) {
  if (playables.length === 0) {
    return playables;
  }

  var convertedPlayables = playables;

  var streams = playables[0].streams;
  var streamsAsPlayableList = [];

  if (Array.isArray(streams) && streams.length > 0) {
    playables.map(function (playable) {
      if (!(playable.streams && playable.streams.length > 0)) {
        throw new Error('All playables must contain streams');
      }

      streamsAsPlayableList.push(streamToPlayable(playable));
    });

    convertedPlayables = streamsAsPlayableList;
  }

  return convertedPlayables;
}

function convertPlayable(playable) {
  return playable.streams && playable.streams.length > 0 ? streamToPlayable(playable) : playable;
}